import { render, staticRenderFns } from "./WizardProducts.vue?vue&type=template&id=caf134e0&"
import script from "./WizardProducts.vue?vue&type=script&lang=js&"
export * from "./WizardProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WizardProducts.vue"
export default component.exports